const STAKED_ROUTE = {
  STAKED: { NAME: 'Staked', PATH: 'staked' },
  STATUS: {
    NAME: 'StakedStatus',
    PATH: 'status'
  }
};

export { STAKED_ROUTE };
